<template>
  <form
    class="c-searchbox"
    role="search"
    :aria-label="searchFormLabel"
    @submit.prevent="submitPhrase"
  >
    <label
      v-if="searchLabel"
      class="c-searchbox__label"
      :id="generatedId">
      {{ searchLabel }}
    </label>
    <div class="c-searchbox__textfield">
      <input class="c-searchbox__input"
      v-model="phrase"
      type="text"
      :aria-labelledby="searchLabel ? generatedId : ''"
      :aria-label="!searchLabel ? searchInputLabel : ''"
      :autocapitalize="autocapitalize"
      :autocomplete="autocomplete"
      :autocorrect="autocorrect"
      :spellcheck="spellcheck"
      :placeholder="searchPlaceholder" />
      <div
        v-if="phrase"
        class="c-searchbox__cross-button"
        @keydown.enter="clearSearch"
        @click="clearSearch"
        tabindex="0">
        <span
          class="c-searchbox__cross-button-cross">
        </span>
        <span
          class="c-searchbox__cross-button-cross">
        </span>
      </div>
    </div>
    <button
      v-if="searchButton"
      type="submit"
      class="c-searchbox__button">
      {{ searchButton }}
    </button>
  </form>
</template>

<script>
export default {
  data () {
    return {
      generatedId: String,
      phrase: ''
    }
  },

  methods: {
    clearSearch () {
      this.phrase = ''
      this.$emit('clear-search', '')
    },

    submitPhrase () {
      if (this.phrase.length >= this.characters) {
        this.$emit('submit-search', this.phrase)
      } else {
        this.$emit('submit-search','')
      }
    },
  },

  mounted () {
    if(this.searchLabel) {
      this.generatedId = this.searchLabel.toLowerCase().split(' ').join('-').concat('-'+Math.floor(1000 + Math.random() * 9000))
    }
  },

  props: {
    searchLabel: String,
    searchFormLabel: String,
    searchInputLabel: String,
    searchPlaceholder: String,
    searchButton: String,
    autocapitalize: {
      type: String,
      default: "off"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    autocorrect: {
      type: String,
      default: "off"
    },
    spellcheck : {
      type: String,
      default: "false"
    },
    characters: {
      type: Number,
      default: null
    },
    showResultsWhileTyping: {
      type: String,
      default: "on"
    }
  },

  watch: {
    "phrase": function(value) {
      if (this.showResultsWhileTyping === 'on') {
        // if characters are set to 0, don't submit
        if(this.characters > 0) {
          this.submitPhrase()
        }
      }
    }
  }
}
</script>

<style lang="scss">
@mixin btnReset() {
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;

  background: transparent;

  /* inherit font & color from ancestor */
  color: inherit;
  font: inherit;

  /* Normalize `line-height`. Cannot be changed from `normal` in Firefox 4+. */
  line-height: normal;

  /* Corrects font smoothing for webkit */
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;

  /* Corrects inability to style clickable `input` types in iOS */
  -webkit-appearance: none;
}
.c-searchbox__label,
.c-searchbox__textfield,
.c-searchbox__input,
.c-searchbox__button {
  line-height: 2rem;
}
.c-searchbox__label {
  padding-right: 1rem;
}
.c-searchbox__textfield {
  position: relative;
  display: inline;
}
.c-searchbox__input {
  padding: 0 2rem 0 .5rem;
}
.c-searchbox__cross-button {
  position: absolute;
  right: .5rem;
  top: 0rem;

  width: 1rem;
  height: 1rem;
}
.c-searchbox__cross-button-cross {
  position: absolute;
  right: .5rem;
  transform: rotate(45deg);

  height: 1rem;

  background-color: #000;
  color: #000;
  border: 1px solid #000;

  cursor: pointer;
}
.c-searchbox__cross-button-cross:last-child {
  transform: rotate(-45deg);
}
.c-searchbox__button {
  @include btnReset()
}
</style>
